import React from 'react';
import { Tag } from 'antd';

const SymptomsQueryTags = ({ node }) => {
    if (!node) return null;

    // if it's a simple term node
    if (node.term) {
        return (<div>
            <Tag className="custom-tag">{node.term}</Tag>
        </div>)
    }

    // if it's a logical node (AND / OR)
    const { operator, children } = node;

    return (
        <div className="custom-tag-container">
            {/* {children.length > 1 && <span>(</span>} */}
            {children.map((child, index) => (
                <React.Fragment key={index}>
                    <SymptomsQueryTags node={child} />
                    {index < children.length - 1 && (<span>{operator}</span>)}
                </React.Fragment>
            ))}
            {/* {children.length > 1 && <span>)</span>} */}
        </div>
    );
};

export default SymptomsQueryTags
